import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Home from "./Home";
import Proposal from "./Proposal";
import UpdatedProposal from './UpdatedProposal';
import JandCLanguages from './JandCLanguages';
import PodcastProposal from './PodcastProposal';
import FounderService from './FounderService';
import ProposalPage from './FounderBrandProgram';
import AIRapGuide from './AIRapGuide';
import RajSocialSEO from './RajSocialSEO';
import KushReport1 from './reports/kush/KushReport1';
import KushReport2 from './reports/kush/KushReport2';
import KushReport3 from './reports/kush/KushReport3';
import KushReport4 from './reports/kush/KushReport4';
import KushReport6 from './reports/kush/KushReport6';
import KushReport7 from './reports/kush/KushReport7';
import KushReport8 from './reports/kush/KushReport8';
import AbhinavReport1 from './reports/abhinav/AbhinavReport1';
import Kush60Day from './reports/kush/Kush60Day';
import KushYouTubePitch from './KushYouTubePitch';
import SocialSeoPlans from './SocialSeoPlans';
// MainHub is intentionally NOT imported here — the directory now lives PRIVATELY
// behind Tailscale (https://srv1468083.taildaaf36.ts.net). Dropping the import
// tree-shakes the full page registry (incl. Internal-page descriptions) out of
// the public bundle. src/MainHub.js + src/pages.js are kept for the private hub.
import FoundersDreamProposal from './FoundersDreamProposal';
import AshmitSocialSEO from './AshmitSocialSEO';
import TFDQuotation from './TFDQuotation';
import KushContentPlan from './KushContentPlan';
import KushGrowthPlan from './KushGrowthPlan';
import KushFootballProposal from './KushFootballProposal';
import BrandQuotation from './BrandQuotation';
import TomJosephProposal from './TomJosephProposal';
import AbhiveerReport from './reports/abhiveer/AbhiveerReport';
import AbhiveerNetworkReport from './reports/abhiveer/may/AbhiveerNetworkReport';
import AbhiveerFinalReport from './reports/abhiveer/final/AbhiveerFinalReport';
import AbhiveerPhase2Proposal from './reports/abhiveer/phase2/AbhiveerPhase2Proposal';
import AbhiveerJulyReport from './reports/abhiveer/july/AbhiveerJulyReport';
import AbhiveerProposal from './AbhiveerProposal';
import AbhiveerPodcast from './AbhiveerPodcast';
import AbhiveerContentOps from './AbhiveerContentOps';
import AbhiveerCourtReady from './AbhiveerCourtReady';
import ShreyaProposal from './ShreyaProposal';
import VisuAIProposal from './VisuAIProposal';
import AIVideoProposal from './AIVideoProposal';
import LeosPrideProposalV2 from './LeosPrideProposalV2';
import LeosPrideCallWalkthrough from './LeosPrideCallWalkthrough';
import TVSReport from './reports/tvs/TVSReport';
import TVSCampaignOverview from './reports/tvs/TVSCampaignOverview';
import SachinReport from './reports/sachin/SachinReport';
import SachinReportApril from './reports/sachin/SachinReportApril';
import SachinReportJune from './reports/sachin/SachinReportJune';
import SourceLabReport1 from './reports/source-lab/SourceLabReport1';
import SourceLab90Day from './reports/source-lab/SourceLab90Day';
import Layout from './Layout';
import RadhaOnboarding from './RadhaOnboarding';
import AbhinavOnboarding from './AbhinavOnboarding';
import DebmitaOnboarding from './DebmitaOnboarding';
import NidhiOnboarding from './NidhiOnboarding';
import JandCOsProposal from './JandCOsProposal';
import GrantPitchDeck from './GrantPitchDeck';
import LinkdProposal from './LinkdProposal';
import OnePrasthaProposal from './OnePrasthaProposal';
import ChrisPocketProposal from './ChrisPocketProposal';
import RadhaPersonalBrand from './RadhaPersonalBrand';
import RadhaStrategyV3 from './RadhaStrategyV3';
import KislayContentEngine from './KislayContentEngine';
import DebmitaPersonalBrand from './DebmitaPersonalBrand';
import AbhinavPersonalBrand from './AbhinavPersonalBrand';
import SmritiIraniBrief from './SmritiIraniBrief';
import AbirShowEngine from './AbirShowEngine';
import SeemaPandeyPersonalBrand from './SeemaPandeyPersonalBrand';
import NidhiPersonalBrand from './NidhiPersonalBrand';
import ShantanuPersonalBrand from './ShantanuPersonalBrand';
import ShaktiPersonalBrand from './ShaktiPersonalBrand';
import RishiPersonalBrand from './RishiPersonalBrand';
import QalakaarSprint from './QalakaarSprint';
import FarazPersonalBrand from './FarazPersonalBrand';
import FarazStrategy from './FarazStrategy';
import SnaptrudeOnboarding from './SnaptrudeOnboarding';
import ChandraStrategy from './ChandraStrategy';
import SanchitStart from './SanchitStart';
import SanchitStrategy from './SanchitStrategy';
import SanchitOnboarding from './SanchitOnboarding';
import AdityaStrategy from './AdityaStrategy';
import SourceProStrategy from './SourceProStrategy';
import NomhConsult from './NomhConsult';
import JayakrishnanPersonalBrand from './JayakrishnanPersonalBrand';
import BrandQuestionnaire from './BrandQuestionnaire';
import KaustubhQuestionnaire from './KaustubhQuestionnaire';
import PranayPersonalBrand from './PranayPersonalBrand';
import PranayStrategy from './PranayStrategy';
import PranayOnboarding from './PranayOnboarding';
import ShantanuOnboarding from './ShantanuOnboarding';
import PranayPlaybookPlan from './PranayPlaybookPlan';
import PranaySampleChapter from './PranaySampleChapter';
import CaseStudies from './CaseStudies';
import Proof from './Proof';
import AutomationsPortfolio from './AutomationsPortfolio';
import SahilYouTubePlan from './SahilYouTubePlan';
import SnaptrudeCast from './SnaptrudeCast';
import TfbOctoberReport from './reports/sanchit/TfbOctoberReport';
import SnaptrudePersonas from './SnaptrudePersonas';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/proposal" element={<Proposal />} />
          <Route path="/updated-proposal" element={<UpdatedProposal />} />
          <Route path="/jandc-languages" element={<JandCLanguages />} />
          <Route path="/podcast-proposal" element={<PodcastProposal />} />
          <Route path="/founder-service" element={<FounderService />} />
          <Route path="/founder-brand-program" element={<ProposalPage />} />
          <Route path="/airapguide" element={<AIRapGuide />} />
          <Route path="/raj-socialseo" element={<RajSocialSEO />} />
          {/* Per-client report routes — each client only gets their own URL */}
          <Route path="/reports/kush/report1" element={<KushReport1 />} />
          <Route path="/reports/kush/report2" element={<KushReport2 />} />
          <Route path="/reports/kush/report3" element={<KushReport3 />} />
          <Route path="/reports/kush/report4" element={<KushReport4 />} />
          <Route path="/reports/kush/report6" element={<KushReport6 />} />
          <Route path="/reports/kush/report7" element={<KushReport7 />} />
          <Route path="/reports/kush/july" element={<KushReport8 />} />
          <Route path="/reports/abhinav/month-1" element={<AbhinavReport1 />} />
          <Route path="/reports/kush/report8" element={<Navigate to="/reports/kush/july" replace />} />
          <Route path="/reports/kush/60-day" element={<Kush60Day />} />
          <Route path="/reports/sachin/30-day" element={<SachinReport />} />
          <Route path="/reports/sachin/april" element={<SachinReportApril />} />
          <Route path="/reports/sachin/3-month" element={<SachinReportJune />} />
          <Route path="/reports/sachin/june" element={<Navigate to="/reports/sachin/3-month" replace />} />
          <Route path="/reports/source-lab/60-day" element={<SourceLabReport1 />} />
          <Route path="/reports/source-lab/90-day" element={<SourceLab90Day />} />
          <Route path="/reports/abhiveer/30-day" element={<AbhiveerReport />} />
          <Route path="/reports/abhiveer/network" element={<AbhiveerNetworkReport />} />
          <Route path="/reports/abhiveer/final" element={<AbhiveerFinalReport />} />
          <Route path="/reports/abhiveer/phase-2" element={<AbhiveerPhase2Proposal />} />
          <Route path="/reports/abhiveer/july" element={<AbhiveerJulyReport />} />
          <Route path="/reports/tvs/scooter" element={<TVSReport />} />
          <Route path="/reports/tvs/overview" element={<TVSCampaignOverview />} />

          {/* Legacy redirects — preserve existing share links */}
          <Route path="/reports/kushreport1" element={<Navigate to="/reports/kush/report1" replace />} />
          <Route path="/reports/kushreport2" element={<Navigate to="/reports/kush/report2" replace />} />
          <Route path="/reports/kushreport3" element={<Navigate to="/reports/kush/report3" replace />} />
          <Route path="/reports/kushreport4" element={<Navigate to="/reports/kush/report4" replace />} />
          <Route path="/reports/kushreport7" element={<Navigate to="/reports/kush/report7" replace />} />
          <Route path="/reports/khushreport1" element={<Navigate to="/reports/kush/report1" replace />} />
          <Route path="/sachin-report" element={<Navigate to="/reports/sachin/30-day" replace />} />
          <Route path="/abhiveer-report" element={<Navigate to="/reports/abhiveer/30-day" replace />} />
          <Route path="/abhiveer-network-report" element={<Navigate to="/reports/abhiveer/network" replace />} />
          <Route path="/tvs-scooter-report" element={<Navigate to="/reports/tvs/scooter" replace />} />
          <Route path="/tvs-campaign-overview" element={<Navigate to="/reports/tvs/overview" replace />} />

          <Route path="/kush-youtube-pitch" element={<KushYouTubePitch />} />
          <Route path="/socialseoplans" element={<SocialSeoPlans />} />
          <Route path="/founder-ai-clone" element={<SocialSeoPlans />} />
          {/* Public directory retired — moved private (Tailscale). Redirect to Home. */}
          <Route path="/main-hub" element={<Navigate to="/" replace />} />
          <Route path="/ashmit-socialseo" element={<AshmitSocialSEO />} />
          <Route path="/founders-dream" element={<FoundersDreamProposal />} />
          <Route path="/tfd-quotation" element={<TFDQuotation />} />
          <Route path="/kush-content-plan" element={<KushContentPlan />} />
          <Route path="/kush-growth-plan" element={<KushGrowthPlan />} />
          <Route path="/kush-football-page" element={<KushFootballProposal />} />
          <Route path="/custom-socialseo-proposal" element={<BrandQuotation />} />
          <Route path="/tom-joseph-proposal" element={<TomJosephProposal />} />
          <Route path="/abhiveer-proposal" element={<AbhiveerProposal />} />
          <Route path="/abhiveer-podcast" element={<AbhiveerPodcast />} />
          <Route path="/abhiveer-content-ops" element={<AbhiveerContentOps />} />
          <Route path="/abhiveer-court-ready" element={<AbhiveerCourtReady />} />
          <Route path="/shreya-proposal" element={<ShreyaProposal />} />
          <Route path="/visu-ai-proposal" element={<VisuAIProposal />} />
          <Route path="/ai-video-proposal" element={<AIVideoProposal />} />
          <Route path="/leos-pride-proposal-v2" element={<LeosPrideProposalV2 />} />
          <Route path="/leos-pride-call-walkthrough" element={<LeosPrideCallWalkthrough />} />
          <Route path="/leos-pride-onboarding" element={<RadhaOnboarding />} />
          <Route path="/abhinav-onboarding" element={<AbhinavOnboarding />} />
          <Route path="/debmita-onboarding" element={<DebmitaOnboarding />} />
          <Route path="/nidhi-onboarding" element={<NidhiOnboarding />} />
          <Route path="/pranay-onboarding" element={<PranayOnboarding />} />
          <Route path="/shantanu-onboarding" element={<ShantanuOnboarding />} />
          <Route path="/jandc-os-proposal" element={<JandCOsProposal />} />
          <Route path="/grant-pitch-deck" element={<GrantPitchDeck />} />
          <Route path="/linkd-proposal" element={<LinkdProposal />} />
          <Route path="/oneprastha-proposal" element={<OnePrasthaProposal />} />
          <Route path="/chris-pocket-proposal" element={<ChrisPocketProposal />} />
          <Route path="/radha-personal-brand" element={<RadhaPersonalBrand />} />
          <Route path="/radha-strategy-v3" element={<RadhaStrategyV3 />} />
          <Route path="/kislay-content-engine" element={<KislayContentEngine />} />
          <Route path="/dyod-content-engine" element={<KislayContentEngine />} />
          <Route path="/debmita-personal-brand" element={<DebmitaPersonalBrand />} />
          <Route path="/abhinav-personal-brand" element={<AbhinavPersonalBrand />} />
          <Route path="/smriti-irani" element={<SmritiIraniBrief />} />
          <Route path="/shakti-personal-brand" element={<ShaktiPersonalBrand />} />
          <Route path="/abir-show-engine" element={<AbirShowEngine />} />
          <Route path="/dr-seema-personal-brand" element={<SeemaPandeyPersonalBrand />} />
          <Route path="/nidhi-personal-brand" element={<NidhiPersonalBrand />} />
          <Route path="/shantanu-personal-brand" element={<ShantanuPersonalBrand />} />
          <Route path="/rishi-personal-brand" element={<RishiPersonalBrand />} />
          <Route path="/qalakaar-sprint" element={<QalakaarSprint />} />
          <Route path="/galakaar-sprint" element={<Navigate to="/qalakaar-sprint" replace />} />
          <Route path="/faraz-personal-brand" element={<FarazPersonalBrand />} />
          <Route path="/faraz-strategy" element={<FarazStrategy />} />
          <Route path="/snaptrude-onboarding" element={<SnaptrudeOnboarding />} />
          <Route path="/chandra-strategy" element={<ChandraStrategy />} />
          <Route path="/sanchit-start" element={<SanchitStart />} />
          <Route path="/sanchit-strategy" element={<SanchitStrategy />} />
          <Route path="/sanchit-onboarding" element={<SanchitOnboarding />} />
          <Route path="/aditya-strategy" element={<AdityaStrategy />} />
          <Route path="/sourcepro-strategy" element={<SourceProStrategy />} />
          <Route path="/sahil-youtube-plan" element={<SahilYouTubePlan />} />
          <Route path="/snaptrude-creators" element={<SnaptrudePersonas />} />
          <Route path="/snaptrude-cast" element={<SnaptrudeCast />} />
          <Route path="/tfb-october-report" element={<TfbOctoberReport />} />
          <Route path="/nomh-consult" element={<NomhConsult />} />
          <Route path="/jayakrishnan-personal-brand" element={<JayakrishnanPersonalBrand />} />
          <Route path="/brand-questionnaire" element={<BrandQuestionnaire />} />
          <Route path="/kaustubh-questionnaire" element={<KaustubhQuestionnaire />} />
          <Route path="/pranay-personal-brand" element={<PranayPersonalBrand />} />
          <Route path="/pranay-strategy" element={<PranayStrategy />} />
          <Route path="/pranay-playbook-plan" element={<PranayPlaybookPlan />} />
          <Route path="/pranay-sample-chapter" element={<PranaySampleChapter />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/proof" element={<Proof />} />
          <Route path="/automations" element={<AutomationsPortfolio />} />

          {/* Catch-all — unknown/guessed routes go to Home, never a blank probe page.
              Explicit routes above (incl. legacy redirects) always match first. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  </React.StrictMode>,
);
